import styled from "styled-components";
import { zIndex } from "theme/variables";

export const StyledSiteAlertBanner = styled("div")<{
  $backgroundColor?: string;
  $textColor?: string;
  $fontWeight?: string | number;
}>`
  display: block;
  padding: 0.5rem;
  background-color: ${({ $backgroundColor }) => $backgroundColor ?? "#0088ce"};
  text-align: center;
  position: relative;
  z-index: ${zIndex.banner};
  padding: 1.5rem;
  min-height: 4.25rem;
  p {
    color: ${({ $textColor }) => $textColor ?? "#ffffff"};
    font-size: 1rem;
    font-family: Verizon-NHG-eDS, Helvetica, Arial, sans-serif;
    font-weight: ${({ $fontWeight }) => $fontWeight ?? "bold"};
  }
  a {
    color: ${({ $textColor }) => $textColor ?? "#ffffff"};
  }
`;
